// Angular
import { Component, ComponentFactoryResolver, OnDestroy, OnInit } from '@angular/core';
import { BroadcastService, ModalService, ModalSize } from '@cv-invision/core';
// AG-Grid
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { DataMessageService } from '../service/data-message.service';
import { CreateUpdateDataMessageTypeComponent } from '../create-update-form/create-update-data-message-type/create-update-data-message-type.component'
import { DELETE_DATA_MESSAGE_TYPE } from '../model/data-message.model';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CreateUpdateMilestoneMessageComponent } from '../create-update-form/create-update-milestone-message/create-update-milestone-message.component';
import { CreateUpdateLenderCompanyMessageComponent } from '../create-update-form/create-update-lender-company-message/create-update-lender-company-message.component';
import { Router } from '@angular/router';
import { CreateUpdateAssetsComponent } from '../create-update-form/create-update-assets/create-update-assets.component';

@Component({
	selector: 'cv-data-message-custom-action',
	templateUrl: './custom-action-data-message-cell.component.html',
	styleUrls: ['./custom-action-data-message-cell.component.scss']
})
export class CustomActionDataMessageCellComponent implements ICellRendererAngularComp, OnInit, OnDestroy {
	private atComponentDestroy = new Subject();
	public cellValue: any;
	private label: string;
	private createUpdateComponent: any;

	constructor(
		private componentFactoryResolver: ComponentFactoryResolver,
		private modalService: ModalService,
		private nexsysDataMessageTypeService: DataMessageService,
		private broadcastService: BroadcastService,
		private router: Router
	) { }
	
	ngOnInit(): void {
		this.setConfiguration();
	}
	/**
	 * When the component renders, it got the possible value
	 * @param params
	 */
	agInit(params: ICellRendererParams): void {
		this.cellValue = params.data;
	}

	/**
	 * Set configuration according to routes
	 */
	private setConfiguration()
	{
		const url = this.router.url;

		if (url.indexOf('milestone-message') !== -1) {
			this.label = 'Nexsys Order Message';
			this.createUpdateComponent = CreateUpdateMilestoneMessageComponent;
		}

		if (url.indexOf('data-message-type') !== -1) {
			this.label = 'Data Message Type';
			this.createUpdateComponent = CreateUpdateDataMessageTypeComponent;
		}

		if (url.indexOf('lender-company-message') !== -1) {
			this.label = 'Lender Company Message';
			this.createUpdateComponent = CreateUpdateLenderCompanyMessageComponent;
		}

		if (url.indexOf('assets-on-completion') !== -1) {
			this.label = 'Assets on Completion';
			this.createUpdateComponent = CreateUpdateAssetsComponent;
		}
	}
	
	/**
	 * Edit Data Message Type Configuration
	 */
	onEditDataMessageType(): void {
		this.modalService
			.open({
				componentFactoryResolver: this.componentFactoryResolver,
				component: this.createUpdateComponent,
				data: {
					isEditing: true,
					dataMessage: this.cellValue
				},
				modalConfiguration: {
					title: `Edit ${this.label} Configuration`,
					modalSize: ModalSize.MD
				}
			})
			.pipe(takeUntil(this.atComponentDestroy))
			.subscribe(result => {
				if (result.success) {
					this.nexsysDataMessageTypeService.setReloadListConfirmation({
						reloadList: true
					});
				} else {
					// it failed :(
				}
			});
	}

	/**
	 * Put back the value
	 * @param params
	 */
	refresh(params: ICellRendererParams): boolean {
		this.cellValue = params;
		return true;
	}

	/**
	 * On Delete Data Message Type.
	 * @param $event
	 */
	onDeleteDataMessageType(): void {
		this.modalService
			.customConfirm(
				`Delete ${this.label}`,
				`Do you want to delete this ${this.label.toLocaleLowerCase()}?`,
				'icon-warning fas fa-exclamation-circle',
				`Delete ${this.label}`,
				'cv-btn-link-error'
			)
			.pipe(takeUntil(this.atComponentDestroy))
			.subscribe(result => {
				if (result.confirm === 'confirm') {
					this.deleteDataMessageType();
				}
			});
	}

	/**
	 * Delete Mapper Data Message Type.
	 * @private
	 */
	private deleteDataMessageType(): void {
		this.broadcastService.broadcast({
			name: DELETE_DATA_MESSAGE_TYPE,
			event: this.cellValue
		});
	}

	ngOnDestroy(): void {
		this.atComponentDestroy.next({});
		this.atComponentDestroy.unsubscribe();
	}
}
